import {
    campaignMetrics,
    ChartDataResponse,
    MetricInfo,
    ChartMetricData,
    ChartMetricValue,
    MetricLabels
} from "@api/common";
import { AppState, Country, currentReportCampaign, flattenCountryData } from "@store";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";

import "./GeoReport.css";
import { Paginator } from "./Paginator/Paginator";
import { formatNumber } from "@common";

interface GeoReportTableComponentProps {
    data: ChartDataResponse;
    metrics: MetricInfo[];
    countries: Country[];
}

function GeoReportTableComponent(props: GeoReportTableComponentProps) {
    return (
        <div className="GeoReport">
            <Paginator
                className="GeoReport__table"
                data={transformGeoData(props.data.metrics, props.countries, props.metrics)}
            />
        </div>
    );
}

export const GeoReportTable = connect(
    (appState: AppState): GeoReportTableComponentProps => {
        const campaign = currentReportCampaign(appState);

        const metrics = campaignMetrics(campaign ? campaign.unit : "CPM");

        const areas = FetchingState.getDataOrDefault(appState.reports.countries, []);

        const regionData = FetchingState.getDataOrDefault(appState.reports.chartData.regionData, {
            dimensions: [],
            metrics: []
        });

        return {
            countries: areas,
            data: regionData,
            metrics
        };
    }
)(GeoReportTableComponent);

function transformGeoData(data: ChartMetricData[], areas: Country[], metrics: MetricInfo[]) {
    const headerData: string[] = ["REGION", "Name"];
    const contentData: any = [];

    const flatAreas = flattenCountryData(areas);

    data.forEach(item => {
        const metric = metrics.find(metricItem => metricItem.metric === item.metric);
        if (!metric) {
            return;
        }

        const getMetricValue = (item: ChartMetricValue, metric: MetricInfo) => {
            const value = item["metric-value"] || 0;

            return metric.isRate ? `${(value * 100).toFixed(2)}%` : formatNumber(value);
        };

        headerData.push(MetricLabels.tableColumnHeader(metric).toUpperCase());
        item.data.forEach((metricItem, index: number) => {
            if (!contentData[index]) {
                const regionCode = metricItem["dimension-values"][0];
                const regionName = (
                    flatAreas.find(a => a.regionIsoCode === regionCode) || {
                        regionName: regionCode
                    }
                ).regionName;

                contentData[index] = [
                    regionCode || "-",
                    <RegionNameColumn regionName={regionName || "Unknown region"} />,
                    getMetricValue(metricItem, metric)
                ];
            } else {
                contentData[index].push(getMetricValue(metricItem, metric));
            }
        });
    });
    return {
        headerData,
        contentData
    };
}

interface RegionNameColProps {
    regionName: string;
}

const RegionNameColumn = (props: RegionNameColProps) => (
    <span className="GeoCol__regionName table-text">{props.regionName}</span>
);
